import React from 'react';
import './style.scss';
import {
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { getLinks } from '../../Containers/Partners/service/partnersLink/actions';
import { connectedAsMaster } from '../../service/user/selector';
import { deepEqual } from '../../utils';
import Alert from '../Alert';

class SelectChildren extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: [],
		};
	}

	// shouldComponentUpdate(nextProps) {
	// 	if (deepEqual(this.props.links, nextProps.links)) {
	// 		return false;
	// 	}

	// 	return true;
	// }

	componentDidMount() {
		if (
			this.props.connectedAsMaster &&
			this.props.prefix &&
			(!this.props.links || (this.props.links && !this.props.links.length))
		) {
			this.props.getPartnerLinks(this.props.prefix);
		}
	}

	checkChild = (checked, id) => {
		if (checked && !this.state.selected.includes(id)) {
			this.setState({ selected: [...this.state.selected, id] });
		} else if (!checked) {
			this.setState({ selected: this.state.selected.filter(i => id !== i) });
		}
	};

	isAllChecked = () => {
		const children = this.getFormatedChildren();
		return (
			children.every(
				c => c.disabled || this.state.selected.includes(c.id_child)
			) && this.state.selected.length
		);
	};

	selectAllChange = () => {
		const children = this.getFormatedChildren();
		if (this.isAllChecked()) {
			this.setState({ selected: [] });
		} else {
			this.setState({
				selected: children.filter(c => !c.disabled).map(c => c.id_child),
			});
		}
	};

	getFormatedChildren = () => {
		const _scope = this.props.scope || [];
		return this.props.children
			.filter(c => {
				if (!c.scope) return true;
				return _scope.every(s => c.scope.includes(s));
			})
			.map(c => {
				if (this.props.prefix && this.props.links) {
					if (!this.props.links[c.id_child]) {
						c.disabled = true;
					}
				}
				return c;
			});
	};

	_onClose = () => {
		this.props.onCancel();
		this.setState({ selected: [] });
	};
	_onValid = () => {
		this.props.onValid([...this.state.selected]);
		this.setState({ selected: [] });
	};

	render() {
		const { open, onCancel, title, description, info } = this.props;

		const _children = this.getFormatedChildren();
		const allChecked = this.isAllChecked();
		const allChildrenDisabled = _children.every(c => c.disabled);

		return (
			<Dialog onClose={onCancel} open={open}>
				<DialogTitle>
					{title || I18n.t('partner.select_children.title')}
				</DialogTitle>

				<DialogContent>
					{info ? <Alert type="info">{info}</Alert> : null}
					<p>{description || ''}</p>

					<div>
						<Checkbox
							checked={allChecked}
							indeterminate={this.state.selected.length && !allChecked}
							onChange={e => this.selectAllChange()}
							color="primary"
							disabled={allChildrenDisabled}
						/>
						{I18n.t('partner.select_children.select_all')}
					</div>
					{_children.map((item, index) => {
						return (
							<div>
								{item.company}
								<Checkbox
									checked={this.state.selected.includes(item.id_child)}
									onChange={e =>
										this.checkChild(e.target.checked, item.id_child)
									}
									color="primary"
									disabled={item.disabled}
								/>
								{item.disabled ? (
									<span style={{ opacity: 0.5 }}>
										<i> {I18n.t('partner.select_children.no_set')}</i>
									</span>
								) : (
									''
								)}
							</div>
						);
					})}
				</DialogContent>
				<DialogActions>
					<Button onClick={this._onClose} className={'button-cancel'}>
						{I18n.t('general.cancel')}
					</Button>

					<Button
						onClick={this._onValid}
						color="primary"
						variant="contained"
						className={'button-valid'}
						disabled={!this.state.selected.length}>
						{I18n.t('general.valid')}
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}
const mstp = (state, props) => {
	return {
		children: state.service.user.children,
		connectedAsMaster: connectedAsMaster(state),
		links: props.prefix ? state.partnersLink[props.prefix] : {},
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getPartnerLinks: prefix => dispatch(getLinks(prefix)),
	};
};
export default connect(mstp, mapDispatchToProps)(SelectChildren);
